const style = {
  insightsFilters__formControlLabel: {
    color: 'rgba(60, 72, 88, 1)',
  },
  insightsFilters__checkbox: {
    color: 'rgba(0, 0, 0, 0.5)',
  },
  insightsFilters__checkbox_checked: {
    color: 'rgba(0, 0, 0, 1)',
  },
};

export default style;
